import React, { Component } from "react";
import { Button, Icon, Input, Tabs, Tooltip, message } from "antd";
import API_URL from "../../../../common/url";
import $ from '../../../../common/AjaxRequest';
import SetPlanParams from "./SetPlanParams";
import TableC from "../../../basicElement/TableC";
import FeferenceQuote from "./FeferenceQuote";

const TabPane = Tabs.TabPane;

class VisitingPlan extends Component {
    state = {
        data: [],
        loading: false,
        visitGroupingList: [],
        activeKey: '',
        type: 'edit',
    }

    componentDidMount(){
        const { evaluateRecordId } = this.props;
        this.queryVisitGroupingList(evaluateRecordId);
    }

    componentWillReceiveProps(nextProps) {
        const { evaluateRecordId, type } = nextProps;
        const evaluateRecordIdChanged = evaluateRecordId !== this.props.evaluateRecordId;
        this.setState({ type },() => {
            if (evaluateRecordIdChanged) {
                this.queryVisitGroupingList(evaluateRecordId);
            }
        })
    }


    loadData = (evaluateRecordId) => {
        if(!evaluateRecordId) return
        this.setState({ loading: true });
        const { activeKey } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryPlanVisitSummaryList,
            data: {
                evaluateRecordId,
                visitGroupingId: activeKey,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                this.setState({
                    loading: false,
                    data: datas,
                });
            }
        };
        $.sendRequest(options);
    };

    //获取治疗组别
    queryVisitGroupingList = (evaluateRecordId) => {
        if(!evaluateRecordId) return
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryVisitGroupingList,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                this.setState({
                    visitGroupingList: datas,
                    activeKey: datas[0] ? String(datas[0].visitGroupingId) : '',
                },() => {
                    
                    this.loadData(evaluateRecordId);
                });
            }
        };
        $.sendRequest(options);
    };

    getColumns = () => {
        const { type } = this.state;
        const { record, showClient = true } = this.props;
        const { curRole } = sessionStorage;
        const { 
            seniorUserAuth,  //BO(王总)
            talAuth,    //领域leader
            deptBoAuth, //部门BO
            bdBaAuth,  //BD
        } = record;
        const restrict = bdBaAuth || curRole === 'BA' || curRole === 'BAL';
        const columns = [
            {
                title: '访视阶段/周期',
                dataIndex: 'serveName',
                key: 'serveName',
                width: 90,
            }, {
                title: '访视方案',
                dataIndex: 'visitGroupingName',
                key: 'visitGroupingName',
                width: 90,
            }, {
                title: '随机入组例数',
                dataIndex: 'planRandomAmount',
                key: 'planRandomAmount',
                width: 90,
            }, {
                title: '访视次数',
                dataIndex: 'visitTypeNames',
                key: 'visitTypeNames',
                width: 80,
            }, {
                title: '次数/例',
                dataIndex: 'singlePatientVisitCaseNum',
                key: 'singlePatientVisitCaseNum',
                width: 100,
            }, {
                title: <span>单访视工时<Tooltip title="单访视工时=该访视工时*回输系数*给药系数*访视工时系数"><Icon type="info-circle" style={{ color: '#1890ff', marginLeft: 4 }} /></Tooltip></span>,
                dataIndex: 'singlePatientHour',
                key: 'singlePatientHour',
                width: 80,
            }];
        // if (showClient && restrict) {
        //     columns.push({
        //         title: '单病例工时（客户）',
        //         dataIndex: 'singlePatientHourCustomer',
        //         key: 'singlePatientHourCustomer',
        //         width: 100,
        //     });
        // }
        columns.push({
            title: '访视例数',
            dataIndex: 'visitCaseNumTotal',
            key: 'visitCaseNumTotal',
            width: 100,
        }, {
            title: '总访视工时',
            dataIndex: 'totalHour',
            key: 'totalHour',
            width: 100,
        });
        // if (showClient && restrict) {
        //     columns.push({
        //         title: '总工时合计（客户）',
        //         dataIndex: 'totalHourCustomer',
        //         key: 'totalHourCustomer',
        //         width: 100,
        //     }, {
        //         title: '访视费用（客户）',
        //         dataIndex: 'visitAmountCustomer',
        //         key: 'visitAmountCustomer',
        //         width: 100,
        //     });
        // }
        columns.push({
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: 100,
            render: (text, record, index) => {
                const { isNewLine = false } = record;
                return (
                    <span>
                        {
                            isNewLine ? 
                            <Input 
                                placeholder="请输入"
                                style={{width: 80}}
                                value={text}
                                onChange={e => this.handleChange(e.target.value, index, 'remark')}
                            />
                            : text
                        }
                    </span>
                );
            }
        });
        if (type !== 'view') {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 100,
                fixed: 'right',
                render: (text, record, index) => {
                    const { isNewLine = false, serveName} = record;
                    return (
                        serveName === '合计' ? '-' : <span>
                            {
                                isNewLine ? <a onClick={() => this.save(record, index)}>保存</a>
                                :<a onClick={() => this.edit(index)}>修改</a>
                            }
                        </span>
                    );
                }
            })
        }
        return columns;
    };

    handleChange = (value, index, key) => {
        const { data } = this.state;
        data[index][key] = value;
        this.setState({ data });
    }

    edit = (index) => {
        const { data } = this.state;
        data[index].isNewLine = true;
        this.setState({ data });
    }

    save = (record, index) => {
        const { data } = this.state;
        const { evaluateRecordId } = this.props;
        const { evaluateRecordPlanVisitSummaryId } = record;
        const { visitGroupingId, serveName, remark } = data[index];
        if (!visitGroupingId) {
            return message.warning('请选择治疗组别');
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.savePlanVisitSummary,
            data: { 
                evaluateRecordPlanVisitSummaryId,
                visitGroupingId,
                serveName,
                remark,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                data.map(el => {
                    el.isNewLine = false;
                });
                this.setState({ data },()=>this.loadData(evaluateRecordId));
            },
        };
        $.sendRequest(options);
    }

    reset = () => {
        this.setState({
            searchParams: {},
        }, () => {
            this.loadData();
        });
    }

    add = () => {
        const { data } = this.state;
        const params = {
            isNewLine: true,
        };
        data.unshift(params);
        this.setState({ data });
    }

    setVisitPeriodPlan = (type) => {
        const { evaluateRecordId } = this.props;
        $.sendRequest({
            method: 'POST',
            url: API_URL.evaluate.queryVisitGroupingList,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                if (!datas[0]) {
                    message.warning('临床PM参照临床方案预测项目参数下“治疗组别”数据还未配置，无法查看/配置访视周期计划');
                }else{
                    this.SetPlanParamsRef.show(evaluateRecordId, type);
                }
            },
        });
    }

    handleTableChange = (params) => {
        const { evaluateRecordId } = this.props;
        this.setState({
            ...params,
        }, () => {
            this.loadData(evaluateRecordId);
        });
    }

    showFeferenceQuote = () => {
        const { record } = this.props;
        this.FeferenceQuoteRef.show(record);
    }

    handleTabClick = (key) => {
        const { evaluateRecordId } = this.props;
        this.setState({
            activeKey: key,
        },() => {
            this.loadData(evaluateRecordId);
        })
    }

    render() {
        const {
            data,
            loading,
            type = 'edit',
            visitGroupingList,
            activeKey,
        } = this.state;
        const { record, showButn = true } = this.props;
        return (
            <div>
                <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 20 }}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {type !== 'view' &&
                            <div style={{color: 'red', marginRight: 10}} >
                                <Icon type="exclamation-circle"/>
                                <span style={{ marginLeft: 8}}>请先进行计划访视参数设置</span>
                            </div>
                        }
                        { showButn && <Button type="primary" style={{ marginRight: 10 }} onClick={this.showFeferenceQuote}>参考评估</Button>}
                        <Button type="primary" onClick={()=>this.setVisitPeriodPlan(type)}>计划访视参数设置</Button>
                    </div>
                </div>
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                    {visitGroupingList.map(pane => <TabPane tab={pane.visitGroupingName} key={pane.visitGroupingId}></TabPane>)}
                </Tabs>
                <TableC
                    rowKey={'evaluateRecordPlanVisitSummaryId'}
                    data={data}
                    pagination={false}
                    onChange={this.handleTableChange}
                    loading={loading}
                    columns={this.getColumns()}
                />
                <SetPlanParams
                    record={record}
                    loadData={this.loadData}
                    ref={el => this.SetPlanParamsRef = el}
                />
                <FeferenceQuote ref={el => this.FeferenceQuoteRef = el} />
            </div>
        );
    }
}

export default VisitingPlan;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/VisitingPlan.js